module.exports = __webpack_public_path__ + "static/media/portfolio-img6.adfa65a4.jpg";